/**
 * Сервис для управления ловушкой в сделку после ФП
 */
export default [
  '$rootScope',
  '$timeout',
  'addFormService',
  'popupService',
  'rentHelperService',
  'config',
  'placingTermsApi',
  'store',
  function (
    $rootScope,
    $timeout,
    addFormService,
    popupService,
    rentHelperService,
    config,
    placingTermsApi,
    store
  )
{
  this.isVisible = false;
  this.dealRentTrapApplied = false;
  this.isTrapEnabled = false;
  this.currentTimeout = null;

  const shouldInitTrap = () => {
    return addFormService.ad.status === 'published' && getIsTrapEnabled() && !getIsVisible();
  };

  const getIsTrapEnabled = () => {
    return this.isTrapEnabled;
  };

  const setIsTrapEnabled = val => {
    this.isTrapEnabled = !!val;
  };

  const getIsVisible = () => {
    return this.isVisible;
  };

  const setIsVisible = val => {
    this.isVisible = !!val;
  };

  const goToNextStep = (needUpdate = true) => {
    if (this.currentTimeout) {
      $timeout.cancel(this.currentTimeout);
    }
    $rootScope.$broadcast('publishAd');
    this.isVisible = false;
    setIsTrapEnabled(false);
    if (needUpdate) {
      $rootScope.$apply();
    }
  };

  const applyDealRent = () => {
    addFormService.ad.dealRentData = {
      applyDealRentVersion: 'v2',
      applyDealRentSource: 'afterAddForm',
    };
    this.dealRentTrapApplied = true;
    // $rootScope.$apply();
    this.currentTimeout = $timeout(() => {
      goToNextStep();
    }, 5000);
  };

  const openModal = () => {
    popupService.openPopup('dealRentTrapAfterFp', { onApprove: applyDealRent, onDecline: () => goToNextStep(false) });
  };

  const chooseDealRentStep = () => {
    if (this.isVisible && this.isTrapEnabled) {
      return this.dealRentTrapApplied ? 'deal-rent-trap-after-fp-final' : 'deal-rent-trap-after-fp';
    }
    return false;
  };

  const experimentName = config.get('dealRentTraps.experiment.name');
  const { abExperiments } = store.getState();
  const isInExperiment = abExperiments[experimentName] === '2';

  $rootScope.$watchGroup(
    [
      () => rentHelperService.isDealRentAvailable(),
      () => placingTermsApi.isRealtorHelpNeeded,
    ], ([isDealRentAvailable, isRealtorHelpNeeded]) => {
      setIsTrapEnabled(isDealRentAvailable && isInExperiment && !isRealtorHelpNeeded);
  });

  return {
    shouldInitTrap,
    getIsTrapEnabled,
    setIsTrapEnabled,
    getIsVisible,
    setIsVisible,
    applyDealRent,
    goToNextStep,
    chooseDealRentStep,
    openModal,
  };
}];
